import { Component, OnInit, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { AdministradoraService } from 'src/app/admihair/service/administradora.service';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';


@Component({
  selector: 'app-usuario-detalhar',
  templateUrl: './usuario-detalhar.component.html',
  styleUrls: ['./usuario-detalhar.component.scss']
})
export class UsuarioDetalharComponent implements OnInit {

  id?: number;
  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: 'Cliente salvo' }];
  messagemVisivel: boolean = false;
  loadingUsuario: boolean = false;
  usuario?: Usuario;
  administradoras: Administradora[] = [];
  empresas: Empresa[] = [];

  
  constructor( private usuarioService: UsuarioService,
    private erroService: ErroService,
    private empresaService: EmpresaService,
    private administradoraService: AdministradoraService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.loadingUsuario = true;
    this.carregarIdUsuario();
    this.buscarUsuarioPorId();
  }

  buscarUsuarioPorId(){
    this.usuarioService.buscarPorId(this.id).subscribe({
      next: (data: Usuario) => {
        this.loadingUsuario = false;
        this.carregarAdministradorasUsuario()
        this.carregarEmpresasUsuario();
        this.usuario = data;
        
      },
      error: (err: any) => {
        this.loadingUsuario = false;

      }
    })
  }

  carregarAdministradorasUsuario(){
    this.administradoraService.listarAdminstradorasPorUsuarioId(this.id).subscribe({
      next: (data: Administradora[]) => {
        this.administradoras = data;
      },
      error: (err: any) => {
        console.log('erro buscar contrato: ', err);
      }
    });
  }

  carregarEmpresasUsuario(){
    this.empresaService.listarPorUsuarioId(this.id).subscribe({
      next: (data: Empresa[]) => {
        this.empresas = data;
      },
      error: (err: any) => {
        console.log('erro buscar contrato: ', err);
      }
    });
  }



  carregarIdUsuario(){
    const idParam = this._activatedRoute.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }


  navigateToFirstChild() {
    this._router.navigate(["/auth/login"], { relativeTo: this._activatedRoute })
  }

  editarIndicadorCliente(id: number){
    this._router.navigate(["/apps/indicador-cliente/editar/" + id], { relativeTo: this._activatedRoute })
  }


}
